import React from 'react';
import { Text } from '@doda/io-react/common';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import { SectionItem } from '../../SectionItem';

/**
 * targetMemberのProps
 */
interface TargetMemberProps {
  /** 概要 */
  targetMemberOutline: string;
  /** 詳細 */
  targetMemberDetail: string;
}

/**
 * 対象となる方を表示するコンポーネント
 *
 * @param {string} props.targetMemberOutline - 概要
 * @param {string} props.targetMemberDetail - 詳細
 */
export const TargetMember: React.FC<TargetMemberProps> = ({
  targetMemberOutline,
  targetMemberDetail,
}) => {
  return (
    <SectionItem label="対象となる方">
      <Text weight="bold" style={{ marginBottom: '16px' }}>
        <TextWithLF text={targetMemberOutline} />
      </Text>

      {targetMemberDetail && <TextWithLF text={targetMemberDetail} />}
    </SectionItem>
  );
};
